import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

interface IProps {
  total: number;
}

const Total: FC<IProps> = ({ total }) => {
  const { t } = useTranslation();

  if (!total) {
    return null;
  }

  return <Typography variant="subtitle2">{t('components:xPerson', { count: total })}</Typography>;
};

export default Total;
